import script from "./ActivityEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityEdit.vue?vue&type=script&setup=true&lang=js"

import "./ActivityEdit.vue?vue&type=style&index=0&id=f3baa9b2&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3baa9b2"]])

export default __exports__